import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './OrderInfoScreen';
import OrderInfo from './OrderInfoScreen';
import { StoreState } from 'src/store/reducers';
import { getOrder, getFiles } from 'src/store/actions/order-actions';
import { QueryParams } from '../../../../../../types/grid';
import { getStudents } from '../../../../../../store/actions/student-actions';

function mapStateToProps(state: StoreState): StateProps {
    return {
        order: state.orders.current,
        files: state.orders.currentFiles,
        students: state.students.data,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getData: (id) => dispatch(getOrder(id)),
        getStudentsAct: (params: QueryParams) => dispatch(getStudents(params)),
        getFiles: (id) => dispatch(getFiles(id)),
    };
}

const OrderInfoScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(OrderInfo);

export default OrderInfoScreen;
